// extracted by mini-css-extract-plugin
module.exports = {"col":"Cases_col__1fntO","container":"Cases_container__7YMng"};